import React from 'react';
import { SettingsPage as SettingsPageComponent } from '../../components/settings';

const SettingsPage: React.FC = () => {
  return <SettingsPageComponent />;
};

export default SettingsPage;
